// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import { get } from 'lodash/fp';
import { TweenMax, Elastic } from 'gsap';
import t from 'app/utils/translate';
import BlockSpinner from 'app/components/commons/BlockSpinner';
import Button from '../commons/Button';

type Props = {
  className?: string,
  currentStep?: number,
  disabled?: boolean,
  label?: string,
  isAnimating?: boolean,
  onAutoFill: () => void,
  numUnlocked: number
};

const LockDiv = styled.div({
  position: 'relative',
  width: 32,
  height: 30,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const StretchButton = styled(Button)({
  flexBasis: '50%',
  justifyContent: 'space-between',
  alignItems: 'center',
  outline: 'none'
});

const LockIcon = styled(({ className, locked }) => (
  <span className={`${className} ${locked ? 'ion-locked' : 'ion-unlocked'}`} />
))({});

class AutofillButton extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    className: undefined,
    label: 'AutoFill',
    currentStep: 0,
    disabled: false,
    isAnimating: false
  };

  componentDidUpdate(prevProps: Props) {
    // bobble the lock to show a connection between the lock button and the autofill button
    // only animate the lock when you directly click a lock on or off
    const { currentStep, numUnlocked } = this.props;

    if (prevProps.numUnlocked !== numUnlocked && prevProps.currentStep === currentStep) {
      TweenMax.fromTo(
        get('current', this.lockRef),
        1.1,
        { scale: 2.2 },
        { scale: 1, ease: Elastic.easeOut }
      );
    }
  }

  lockRef = React.createRef();

  render() {
    const { className, disabled, isAnimating, label, numUnlocked, onAutoFill } = this.props;
    return (
      <StretchButton
        autoBorderRadius={false}
        className={className}
        size="small"
        onClick={!disabled ? onAutoFill : undefined}
        kind="primary"
        disabled={disabled}
        style={{
          display: 'flex'
        }}
      >
        {t(label)}
        <LockDiv ref={this.lockRef}>
          {!isAnimating ? <LockIcon locked={numUnlocked === 0} /> : <BlockSpinner />}
        </LockDiv>
      </StretchButton>
    );
  }
}

export default AutofillButton;
